import {createConfig, http } from "wagmi";
import {ALL_SUPPORTED_CHAIN_IDS, SupportedChainId} from "constants/chains";
import {RPC_URLS} from "constants/networks";
import ms from "ms.macro";
import cratLogo from "../assets/svg/crat-logo.svg";
import cratLogoCircle from "../assets/images/crat-circle.png";
import {NetworkType} from "../constants/chainInfo";
import * as wagmiChains from 'wagmi/chains';
import {Chain, defineChain, Transport} from "viem";
import {Chains} from "./wallet-connect";

const PROVIDER_BATCH_TIME = 200;
const PROVIDER_MAX_BATCH = 25;
const PROVIDER_RETRY_COUNT = 1;
export const PROVIDER_POLLING_INTERVAL = 15_000;

export const buildTransports = (): Record<SupportedChainId, Transport> => {
  return ALL_SUPPORTED_CHAIN_IDS.reduce(
    (acc, chainId: SupportedChainId) => {
      acc[chainId] = http(RPC_URLS[chainId][0], {
        batch: {
          wait: PROVIDER_BATCH_TIME,
          batchSize: PROVIDER_MAX_BATCH,
        },
        retryCount: PROVIDER_RETRY_COUNT,
      });

      return acc;
    },
    {} as Record<SupportedChainId, Transport>,
  );
};

export const cratD2CTestnet = defineChain({
  id: 65349,
  name: 'CratD2C Testnet',
  testnet: true,
  nativeCurrency: {
    decimals: 18,
    name: 'CRAT',
    symbol: 'CRAT',
  },
  rpcUrls: {
    public: { http: ['https://cratd2c-testnet-node1.cratd2csmartchain.io'] },
    default: { http: ['https://cratd2c-testnet-node1.cratd2csmartchain.io'] },
  },
  blockExplorers: {
    default: {
      name: 'CratD2C Explorer',
      url: 'https://explorer-testnet.cratd2csmartchain.io',
    },
  },
});

const allChains = [cratD2CTestnet] as const;
const normalizedWagmiChains = allChains.reduce(
  (acc, chain) => {
    acc[chain.id] = chain;
    return acc;
  },
  {} as Record<number, wagmiChains.Chain>,
);
export const wagmiConfig = createConfig({
  chains: allChains,
  multiInjectedProviderDiscovery: false,
  transports: buildTransports(),
  batch: {
    multicall: false,
  },
  pollingInterval: PROVIDER_POLLING_INTERVAL,
});
